import React, { useState } from "react";
import { submitPartnership, errMessage } from "@/lib/api";
import { Loader2, Check, ArrowRight } from "lucide-react";

export default function Partnership() {
  const [f, setF] = useState({ business_name: "", contact_name: "", mobile: "", email: "", partner_type: "dealer", city: "", monthly_volume: "", notes: "" });
  const [b, setB] = useState(false); const [ok, setOk] = useState(null); const [e, setE] = useState("");
  const on = (k) => (ev) => setF({ ...f, [k]: ev.target.value });
  async function submit(ev) {
    ev.preventDefault(); setE("");
    if (!f.business_name || !f.contact_name || !/^\d{10}$/.test(f.mobile) || !f.city) { setE("Fill business, contact, valid mobile and city."); return; }
    setB(true); try {
      const payload = { ...f, email: f.email?.trim() ? f.email.trim() : undefined };
      setOk(await submitPartnership(payload));
    } catch (err) { setE(errMessage(err)); } finally { setB(false); }
  }

  return (
    <main data-testid="partnership-page" className="pt-16 md:pt-20">
      <section className="bg-[hsl(222_47%_11%)] text-white grain relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
          <p className="chapter-index text-emerald-400">Partners · Dealers · Brokers · DSAs</p>
          <h1 className="font-display text-5xl md:text-8xl leading-[0.92] mt-3 max-w-4xl">Grow with a <span className="italic text-emerald-400">financing partner</span> that ships fast.</h1>
          <p className="mt-6 text-slate-300 max-w-2xl">Digital-first onboarding, transparent commissions, multi-lender routing, and a partner desk that actually responds.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid md:grid-cols-2 gap-6">
          {[
            ["Multi-lender routing", "One integration, 51+ finance partners. Best-fit selection happens automatically."],
            ["Transparent commissions", "Structured payout grid published upfront. Monthly reconciliation."],
            ["Digital onboarding", "e-KYC, digital agreements, direct disbursal — reduce your paperwork by 80%."],
            ["Partner desk", "Named partner manager for every dealer with SLA-backed response times."],
          ].map(([t, d]) => (
            <div key={t} className="rounded-3xl border border-black/[0.06] bg-white p-8">
              <p className="font-display text-3xl">{t}</p>
              <p className="mt-3 text-slate-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <p className="chapter-index text-emerald-700">Get onboarded</p>
        <h2 className="font-display text-4xl md:text-5xl mt-3">Register your dealership.</h2>
        {ok ? (
          <div className="mt-8 rounded-3xl bg-emerald-50 border border-emerald-200 p-8">
            <div className="w-10 h-10 rounded-full bg-emerald-600 grid place-items-center text-white"><Check size={20}/></div>
            <p className="mt-4 font-display text-2xl">Partnership request received.</p>
            <p className="mt-2 text-slate-600">Our partner desk will get in touch within one business day.</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="partner-form" className="mt-8 rounded-3xl bg-white border border-black/[0.06] p-6 md:p-8 grid md:grid-cols-2 gap-3">
            <input required data-testid="p-bname" value={f.business_name} onChange={on('business_name')} placeholder="Business / Dealership name" className="input"/>
            <input required data-testid="p-cname" value={f.contact_name} onChange={on('contact_name')} placeholder="Contact person" className="input"/>
            <input required data-testid="p-mobile" value={f.mobile} onChange={on('mobile')} inputMode="numeric" pattern="\d{10}" placeholder="10-digit mobile" className="input"/>
            <input data-testid="p-email" value={f.email} onChange={on('email')} type="email" placeholder="Email" className="input"/>
            <select data-testid="p-type" value={f.partner_type} onChange={on('partner_type')} className="input">
              <option value="dealer">Dealer</option>
              <option value="broker">Broker</option>
              <option value="dsa">DSA</option>
              <option value="referral">Referral partner</option>
            </select>
            <input required data-testid="p-city" value={f.city} onChange={on('city')} placeholder="City" className="input"/>
            <input data-testid="p-volume" value={f.monthly_volume} onChange={on('monthly_volume')} placeholder="Monthly volume (units)" className="input md:col-span-2"/>
            <textarea data-testid="p-notes" value={f.notes} onChange={on('notes')} placeholder="Notes" rows={3} className="input md:col-span-2"/>
            {e && <p className="md:col-span-2 text-sm text-red-600">{e}</p>}
            <button data-testid="p-submit" disabled={b} className="md:col-span-2 btn-line rounded-full bg-emerald-700 text-white py-3 text-sm inline-flex items-center justify-center gap-2">{b?<Loader2 className="animate-spin" size={16}/>:<>Submit <ArrowRight size={16}/></>}</button>
            <style>{`.input{width:100%;border:1px solid hsl(214 32% 91%);background:#fff;border-radius:1rem;padding:.75rem 1rem;font-size:.9rem;outline:none}.input:focus{border-color:hsl(158 64% 40%)}`}</style>
          </form>
        )}
      </section>
    </main>
  );
}
